module.exports = __webpack_public_path__ + "img/collector.6efb0d8e.svg";